/**
 * General-purpose formatting utilities.
 * All reusable non-datetime formatters live here.
 */

/**
 * Format a duration in milliseconds to a human-readable string.
 * Returns '-' for null inputs.
 */
export function formatDuration(ms: number | null): string {
  if (ms === null) return '-';
  if (ms < 1_000) return `${ms}ms`;
  const secs = Math.round(ms / 1_000);
  if (secs < 60) return `${secs}s`;
  const mins = Math.floor(secs / 60);
  const rem = secs % 60;
  return rem > 0 ? `${mins}m ${rem}s` : `${mins}m`;
}

/**
 * Format a byte count to a human-readable file size string.
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Format duration between two ISO timestamp strings.
 * Returns '' when either input is missing or the difference is negative.
 */
export function formatDurationRange(startedAt: string | null, finishedAt: string | null): string {
  if (!startedAt || !finishedAt) return '';
  const ms = new Date(finishedAt).getTime() - new Date(startedAt).getTime();
  if (ms < 0) return '';
  const totalSecs = Math.round(ms / 1000);
  const mins = Math.floor(totalSecs / 60);
  const secs = totalSecs % 60;
  if (mins === 0) return `${secs}s`;
  return `${mins}m ${secs}s`;
}
